;(function () {

  let main = {}

  // Clone dropdown

  const tooltipTriggerEl = document.querySelector('#copyButton')
  if (tooltipTriggerEl) {
    new bootstrap.Tooltip(tooltipTriggerEl, {trigger: 'manual'})
  }

  main.copyToClipboard = function (event) {
    const input = document.querySelector('.form-control');
    input.select();
    document.execCommand('copy');

    // Show tooltip
    const copyButton = document.getElementById('copyButton');
    const tooltip = bootstrap.Tooltip.getInstance(copyButton);
    tooltip.show();

    // Hide tooltip after 1.5 seconds
    setTimeout(() => {
        tooltip.hide();
    }, 1500);
  }

  main.copyTextToClipboard = function (text, buttonEl) {
    const textarea = document.createElement('textarea');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);

    if (buttonEl) {
      const tooltip = bootstrap.Tooltip.getOrCreateInstance(buttonEl, {trigger: 'manual'});
      tooltip.show();
      setTimeout(() => tooltip.hide(), 1500);
    }
  }

  // end clone dropdown

  var fsetTmpl
  var newNum = 0

  main.initFieldList = function (el) {
    // Deprecated: handled by Stimulus field_list_controller
  }

  main.listFieldAdd = function (el) {
    // Deprecated: handled by Stimulus field_list_controller
  }

  main.listFieldRemove = function (el) {
    // Deprecated: handled by Stimulus field_list_controller
  }

  var ACCEPT_MAP = {
    image: 'image/*',
    video: 'video/*',
  }

  function refreshGlightbox() {
    if (window._glightbox) window._glightbox.destroy()
    if (typeof GLightbox !== 'undefined') {
      window._glightbox = GLightbox({ selector: '.glightbox' })
    }
  }

  function updateThumbnail(data, refs, attributes) {
    var wrapper = refs.url_input.closest('[data-file-field]')
    if (!wrapper) return
    var link = wrapper.querySelector('a.glightbox')
    if (link) {
      link.href = attributes.href
      var img = link.querySelector('img')
      var source = link.querySelector('video source')
      if (img) img.src = attributes.href
      if (source) source.src = attributes.href
    } else if (attributes.href) {
      var thumbContainer = wrapper.querySelector('div.me-3')
      var media = thumbContainer.querySelector('img, video')
      if (media) {
        var a = document.createElement('a')
        a.href = attributes.href
        a.className = 'glightbox'
        a.dataset.type = data.ctype === 'video' ? 'video' : 'image'
        if (data.ctype === 'video') a.dataset.source = 'local'
        media.style.cursor = 'pointer'
        media.parentNode.insertBefore(a, media)
        a.appendChild(media)
        if (media.tagName === 'IMG') media.src = attributes.href
        else {
          var s = media.querySelector('source')
          if (s) s.src = attributes.href
        }
      }
    }
    refreshGlightbox()
  }

  main.onUploadClick = function (data, refs) {
    var file_id = data.field_id + "-file"
    var accept = ACCEPT_MAP[data.ctype] || ''
    var input = document.createElement('input')
    input.id = file_id
    input.type = 'file'
    if (accept) input.accept = accept
    input.addEventListener('change', function () { main.onFileChange(data, refs) })
    refs.hidden.replaceChildren(input)
    input.click()
  }

  main.onFileChange = function (data, refs) {
    var file_input, file, upload_url

    function showProgress() {
      $(refs.progressBar).css('width', '0%')
      $(refs.progress).removeClass('d-none')
    }

    function setProgress(progress) {
      $(refs.progressBar).css('width', progress + '%')
    }

    function hideProgress() {
      $(refs.progress).addClass('d-none')
    }

    function setAttributes(attributes) {
      $(refs.url_input).val(attributes.href)
      updateThumbnail(data, refs, attributes)
      hideProgress()
    }

    function onError() {
      hideProgress()
    }

    showProgress()
    upload_url = data.upload_url
    file_input = $(refs.hidden).find('input')[0]
    if (file_input.files) {
      file = file_input.files[0]
      uploadFile(file, upload_url, setProgress, setAttributes, onError)
    }
  }

  function uploadFile (file, upload_url, progressCallback, successCallback, errorCallback) {
    const params = {
      name: file.name,
      type: file.type
    }
    fetch(_.appendQueryArgs(upload_url, params))
      .then(response => response.json()
        .then(formobj => postToBucket(file, formobj, progressCallback, successCallback, errorCallback)))
  }
  main.uploadFile = uploadFile

  function postToBucket(file, formobj, progressCallback, successCallback, errorCallback) {
    var formData = createFormData(file, formobj.fields)
    var xhr = new XMLHttpRequest()

    xhr.open("POST", formobj.url, true)

    xhr.upload.addEventListener("progress", function(event) {
      var progress = event.loaded / event.total * 100
      progressCallback(progress)
    })

    xhr.addEventListener("load", function(event) {
      if (xhr.status != 204) {
        if (errorCallback) errorCallback()
        _.alert('Upload failed. Make sure the file type matches the field type (e.g. image fields only accept images).', 'danger')
        return
      }
      // proxy_url must be provided by the server
      if (!formobj.proxy_url) {
        if (errorCallback) errorCallback()
        console.error("Server error: proxy_url not provided in upload response")
        return
      }
      var attributes = {
        url: formobj.proxy_url,
        href: formobj.proxy_url,
        name: false,
        size: false
      }
      successCallback(attributes)
    })

    xhr.addEventListener("error", function(event) {
      if (errorCallback) errorCallback()
      _.alert('Upload failed due to a network error.', 'danger')
    })

    xhr.send(formData)
  }

  function createFormData(file, fields) {
    var data = new FormData()
    for (const [key, value] of Object.entries(fields)) {
      data.append(key, value)
    }
    data.append("file", file)
    return data
  }

  function initSortable() {
    document.querySelectorAll(".js-sortable").forEach(el => {
      new Sortable(el, {animation: 150, handle: '.js-sortable-handle'})
    })
  }

  function initCollapseAll(parent) {

    const collapseBtn = parent.querySelector(".js-collapse-all")
    collapseBtn.addEventListener('click', () => {
      parent.querySelectorAll('.collapse').forEach(el => {
        const collapse = bootstrap.Collapse.getOrCreateInstance(el)
        collapse.hide()
      })
    })
    const expandBtn = parent.querySelector(".js-expand-all")
    expandBtn.addEventListener('click', () => {
      parent.querySelectorAll('.collapse').forEach(el => {
        const collapse = bootstrap.Collapse.getOrCreateInstance(el)
        collapse.show()
      })
    })

    document.querySelectorAll(".js-card-title").forEach(elTitle => {
      const elInput = elTitle.closest(".card").querySelector('input[type="text"]')
      if (elInput) {
        elTitle.textContent = elInput.value
        elInput.addEventListener('input', () => {
          elTitle.textContent = elInput.value
        })
      }
    })

  }

  main.initManagementList = function (el) {
    if (typeof Sortable === 'undefined') return
    var container = el.querySelector('.js-sortable-items')
    if (!container) return
    var reorderUrl = container.dataset.reorderUrl
    if (!reorderUrl) return
    new Sortable(container, {
      animation: 150,
      handle: '.js-sortable-handle',
      onEnd: function () {
        var order = Array.from(container.children).map(function (el) {
          return el.dataset.idx
        })
        var form = document.createElement('form')
        form.method = 'POST'
        form.action = reorderUrl
        // Copy CSRF token from meta tag or any existing form
        var csrfInput = document.querySelector('input[name="csrf_token"]')
        if (csrfInput) {
          var hidden = document.createElement('input')
          hidden.type = 'hidden'
          hidden.name = 'csrf_token'
          hidden.value = csrfInput.value
          form.appendChild(hidden)
        }
        // Pass through next_url so the server can redirect back
        var nextUrl = container.dataset.nextUrl
        if (nextUrl) {
          var nextInput = document.createElement('input')
          nextInput.type = 'hidden'
          nextInput.name = 'next_url'
          nextInput.value = nextUrl
          form.appendChild(nextInput)
        }
        order.forEach(function (idx) {
          var input = document.createElement('input')
          input.type = 'hidden'
          input.name = 'order'
          input.value = idx
          form.appendChild(input)
        })
        document.body.appendChild(form)
        form.submit()
      }
    })
  }

  main.initTooltip = function (el) {
    // Deprecated: handled by Stimulus tooltip_controller
  }

  main.initCopyLink = function (el) {
    // Deprecated: handled by Stimulus copy_link_controller
  }

  main.initToggleDisable = function (el) {
    const target = document.getElementById(el.dataset.toggleTarget)
    if (!target) return
    function sync() { target.disabled = el.checked }
    el.addEventListener('change', sync)
    sync()
  }

  main.initClickableRow = function (tr) {
    // Deprecated: handled by Stimulus clickable_row_controller
  }

  // Attach widgets to the page once the DOM is ready.
  //
  // Deferred to a microtask so sibling modules that register main.* init
  // handlers (e.g. submission-modal.js) have run first.  They import after
  // main.js in index.js and module evaluation is synchronous, so without this
  // the dispatch below would fire — onReady runs immediately when the DOM is
  // already parsed — before those handlers exist, throwing on the lookup
  // (RP-DASH-5D).  The guard then keeps one unknown [data-init] from aborting
  // the rest of this callback (GLightbox / Summernote init).
  queueMicrotask(() => _.onReady(function (content) {
    initSortable()
    content.querySelectorAll('[data-init]').forEach(el => {
      const name = el.dataset.init
      const fn = main[name]
      if (typeof fn !== 'function') {
        console.warn(`Unknown data-init handler: ${name}`)
        return
      }
      fn(el)
    })
    if (typeof GLightbox !== 'undefined') {
      if (window._glightbox) {
        window._glightbox.reload()
      } else {
        window._glightbox = GLightbox({ selector: '.glightbox' })
      }
    }
    if (typeof jQuery !== 'undefined') {
      jQuery(content).find('[data-jqinit=summernote]').each(function () {
        const $el = jQuery(this)
        $el.summernote({
          lang: 'en-US',
          callbacks: {
            onImageUpload: (files) => attachments.handleSummerUpload(files, $el),
          },
        })
      })
    }
  }))

  if (typeof jQuery !== 'undefined') {
    jQuery.noConflict()
  }

  addEventListener("trix-attachment-add", attachments.handleTrixUpload)

  window.main = main

})();
